import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "showText", "hideText", "icon"]

  connect() {
    console.log("Disclosure controller connected")
  }

  toggle() {
    console.log("Toggle called")
    this.contentTarget.classList.toggle("hidden")
    this.showTextTarget.classList.toggle("hidden")
    this.hideTextTarget.classList.toggle("hidden")
    this.iconTarget.classList.toggle("rotate-90")
  }
}
